import type { ComponentPropsWithoutRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type { EditorFieldProps } from "./DefaultEditorFields";
import { DefaultEditorFields } from "./DefaultEditorFields";

export interface DefaultEditorFieldsListProps
  extends ComponentPropsWithoutRef<"div"> {
  fields: EditorFieldProps[];
}

export const DefaultEditorFieldsList = ({
  fields,
  className,
}: DefaultEditorFieldsListProps) => (
  <div className={classNames("flex flex-col gap-y-6 px-6 py-4", className)}>
    {fields.map(({ name, propMeta }) => (
      <DefaultEditorFields key={name} name={name} propMeta={propMeta} />
    ))}
  </div>
);
